const config = {
  site: {
    name: "HireReview",
    companyName: "PayReview",
    dashboardPath: "/",
    clientSupportEmail: "support@hirereview.com",
    footerLinks: [
      {
        label: "Contact",
        href: "/contact",
      },
      {
        label: "FAQ",
        href: "/faq",
      },
      {
        label: "Help",
        href: "/help",
      },
    ],
  },
}

export default config
